module.exports = __webpack_public_path__ + "static/media/login_bg.04ffd9b8.jpg";